// Copy contract address
let originalContractAddress = '';

window.copyContract = function() {
    const addressElement = document.getElementById('contractAddress');
    
    // Сохраняем оригинальный адрес при первом вызове
    if (!originalContractAddress) {
        originalContractAddress = addressElement.textContent;
    }
    
    // Всегда копируем оригинальный адрес
    navigator.clipboard.writeText(originalContractAddress).then(() => {
        addressElement.classList.add('copied');
        addressElement.textContent = 'copied';
        
        setTimeout(() => {
            addressElement.classList.remove('copied');
            addressElement.textContent = originalContractAddress;
        }, 2000);
    });
}

// Copy footer contract
let originalFooterContractAddress = '';

window.copyFooterContract = function() {
    const addressElement = document.getElementById('footerContractAddress');
    
    if (!originalFooterContractAddress) {
        originalFooterContractAddress = addressElement.textContent;
    }
    
    navigator.clipboard.writeText(originalFooterContractAddress).then(() => {
        addressElement.classList.add('copied');
        addressElement.textContent = 'copied';
        
        setTimeout(() => {
            addressElement.classList.remove('copied');
            addressElement.textContent = originalFooterContractAddress;
        }, 2000);
    });
}

// Scroll to bottom
function scrollToBottom() {
    const duration = 2000; // 2 секунды вместо дефолтных
    const start = window.pageYOffset;
    const target = document.body.scrollHeight;
    const distance = target - start;
    const startTime = performance.now();

    function scroll(currentTime) {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const ease = progress * (2 - progress); // ease out
        
        window.scrollTo(0, start + distance * ease);
        
        if (progress < 1) {
            requestAnimationFrame(scroll);
        }
    }
    
    requestAnimationFrame(scroll);
}

// Scroll to top
window.scrollToTop = function() {
    window.scrollTo({
        top: 0,
        behavior: 'smooth'
    });
}

// Музыка запускается сразу
const bgMusic = document.getElementById('bgMusic');
if (bgMusic) {
    bgMusic.volume = 0.5;
    bgMusic.play().catch(() => {
        // Если браузер заблокировал - запустим при первом взаимодействии
        const startMusic = () => {
            bgMusic.play();
            document.removeEventListener('click', startMusic);
            document.removeEventListener('touchstart', startMusic);
            document.removeEventListener('scroll', startMusic);
        };
        document.addEventListener('click', startMusic, { once: true });
        document.addEventListener('touchstart', startMusic, { once: true });
        document.addEventListener('scroll', startMusic, { once: true });
    });
}

document.addEventListener('DOMContentLoaded', () => {
    
    // Анимация появления/исчезновения карточек при скролле
    const observerOptions = {
        threshold: 0.15,
        rootMargin: '0px'
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
                entry.target.classList.remove('hidden');
            } else {
                // Если карточка выше viewport (прошли её)
                if (entry.boundingClientRect.top < 0) {
                    entry.target.classList.remove('visible');
                    entry.target.classList.add('hidden');
                }
            }
        });
    }, observerOptions);

    document.querySelectorAll('.character-card').forEach(card => {
        observer.observe(card);
    });

    // Анимация скрытия hero при скролле (с throttling)
    const heroSection = document.querySelector('.hero-section');
    let ticking = false;

    window.addEventListener('scroll', () => {
        if (!ticking) {
            requestAnimationFrame(() => {
                const scrollY = window.pageYOffset;
                if (scrollY > 300) {
                    heroSection.classList.add('scrolled');
                } else {
                    heroSection.classList.remove('scrolled');
                }
                ticking = false;
            });
            ticking = true;
        }
    }, { passive: true });

});

// Дублируем функцию для надежности
if (!window.copyContract) {
    window.copyContract = function(element) {
        const contract = '7kKauHWf4cCNhAf7ScxBguMXxjfrmGhU6m6fSfizpump';
        const originalText = element.textContent;
        
        navigator.clipboard.writeText(contract).then(() => {
            element.textContent = 'COPIED!';
            element.style.color = '#4ade80';
            
            setTimeout(() => {
                element.textContent = originalText;
                element.style.color = '';
            }, 2000);
        }).catch(err => {
            // Fallback для старых браузеров
            const textArea = document.createElement('textarea');
            textArea.value = contract;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            
            element.textContent = 'COPIED!';
            element.style.color = '#4ade80';
            
            setTimeout(() => {
                element.textContent = originalText;
                element.style.color = '';
            }, 2000);
        });
    }
}

